import {createRouter, createWebHistory} from 'vue-router'
import CheckComponent from "@/views/Check-Component.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import SetupComponent from "@/views/Setup-Component.vue";
import HomeComponent from "@/views/Home-Component.vue";


const routes = [
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
  { path: '/', component: CheckComponent, name: 'inicio' },
  { path: '/setup', component: SetupComponent, name: 'setup'},
  { path: '/home', component: HomeComponent, name: 'home' },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
